/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import {
  Divider, makeStyles, Paper, Typography,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'
import RupiasFormat from '@components/RupiasFormat'

const useStyles = makeStyles((theme) => ({
  sectionTotal: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  summaryTitle: {
    fontWeight: 'bold',
  },
  label: {
    color: '#777',
  },
  labelCommission: {
    marginTop: '5px',
    color: 'rgb(75, 174, 160)',
  },
  tableFooter: {
    textAlign: 'left',
  },
  tableFooterRow: {
    height: 35,
  },
  labelTotal: {
    color: '#777',
    fontSize: 16,
  },
  dividerTotal: {
    backgroundColor: '#777',
    marginTop: '-38px',
    marginBottom: '38px',
  },
  dividerCommission: {
    backgroundColor: '#777',
    marginTop: '-74px',
    marginBottom: '74px',
  },
  dividerDeposit: {
    backgroundColor: '#777',
    marginTop: '-110px',
    marginBottom: '110px',
  },
}))

const OrderSummary = ({
  summary, loadSummary, tableTotal, customShippingCost,
  customRow,
}) => {
  const classes = useStyles()
  const commissionTable = tableTotal.find(({ name }) => name === 'formated_commission' || name === 'formatted_commission')
  const totalTable = tableTotal.find(({ name }) => name === 'formatted_total' || name === 'formated_total')
  const warehouseID = JSON.parse(localStorage.getItem('payload'))?.warehouse_id || ''

  return (
    <Paper className={classes.sectionTotal}>
      <Typography
        variant="h6"
        className={classes.summaryTitle}
        gutterBottom
      >
        Ringkasan
      </Typography>
      <Divider />
      <table>
        <tbody>
          {
            tableTotal.map((item, index) => (
              <tr key={index} className={classes.tableFooterRow} style={{ display: item?.name === 'formated_shipping_cost' && summary?.free_shipping && 'none' }}>
                <th className={classes.tableFooter}>
                  <span className={
                      item.label === 'Total' ? classes.labelTotal : item.label === 'Komisi' ? classes.labelCommission : classes.label
                    }
                  >
                    {(warehouseID === summary?.target?.id || warehouseID === summary?.warehouse?.id) && commissionTable && item.label === 'Komisi' ? 'Komisi Dropship' : item.label}
                  </span>
                </th>
                <td
                  align="right"
                  className={
                      item.label === 'Total' ? classes.labelTotal : item.label === 'Komisi' ? classes.labelCommission : classes.label
                    }
                >
                  {item.label === 'Diskon' && summary.formated_discount && '-' }
                  { loadSummary ? <Skeleton width={100} height={25} />
                    : item.label.toLowerCase() === 'ongkos kirim' && customShippingCost > 0 ? <RupiasFormat displayType="text" value={customShippingCost} />
                      : item.label.toLowerCase() === 'total' && customShippingCost > 0 ? <RupiasFormat displayType="text" value={(parseInt(summary?.total) + parseInt(customShippingCost))} />
                        : item.name === 'uniq_code' ? <RupiasFormat displayType="text" value={parseInt(-summary?.uniq_code_reduction)} />
                          : summary[item.name] }
                </td>
              </tr>
            ))
          }
          {
            (warehouseID === summary?.target?.id || warehouseID === summary?.warehouse?.id) && commissionTable && (
              <tr key="total-deposit" className={classes.tableFooterRow}>
                <th className={classes.tableFooter}>
                  <span className={classes.label}>
                    Total Pendapatan(Deposit)
                  </span>
                </th>
                <td
                  align="right"
                  className={classes.label}
                >
                  {loadSummary ? <Skeleton width={100} height={25} /> : <RupiasFormat displayType="text" value={(summary?.total - summary?.commission)} />}
                </td>
              </tr>
            )
          }
        </tbody>
      </table>
      { totalTable && <Divider className={commissionTable && (warehouseID === summary?.target?.id || warehouseID === summary?.warehouse?.id) ? classes.dividerDeposit : commissionTable ? classes.dividerCommission : classes.dividerTotal} /> }
      {!loadSummary && customRow}
    </Paper>
  )
}
export default OrderSummary
